import React from 'react'

type ErrorBoundaryProps = {
  children: React.ReactNode
}

type ErrorBoundaryState = {
  hasError: boolean
  message: string
}

function limparDadosLocais() {
  try {
    localStorage.clear()
    sessionStorage.clear()
  } catch {
    // Ignora navegadores que bloqueiam storage.
  }
}

function getLoginRoute() {
  const isHashRouter = window.location.hash.startsWith('#/')
  return isHashRouter ? '/#/login' : '/login'
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = {
    hasError: false,
    message: '',
  }

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    const message = error instanceof Error ? error.message : 'Erro inesperado ao carregar a aplicação.'
    return { hasError: true, message }
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    console.error('[AgroSchelive] Erro global capturado:', error, info)
  }

  private recarregar = () => {
    window.location.reload()
  }

  private limparERecarregar = () => {
    limparDadosLocais()
    window.location.assign(getLoginRoute())
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background: '#f6f8fb',
        fontFamily: "'Plus Jakarta Sans', Arial, sans-serif",
      }}>
        <div style={{
          width: '100%',
          maxWidth: 520,
          background: '#fff',
          border: '1px solid #e5e7eb',
          borderRadius: 18,
          boxShadow: '0 18px 45px rgba(15, 23, 42, .10)',
          padding: 28,
          textAlign: 'center',
        }}>
          <div style={{
            width: 52,
            height: 52,
            margin: '0 auto 16px',
            borderRadius: 16,
            background: '#eff6ff',
            color: '#1d4ed8',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 24,
          }}>!</div>

          <h1 style={{ fontSize: 22, lineHeight: 1.25, margin: '0 0 8px', color: '#111827' }}>
            Não foi possível carregar o AgroSchelive
          </h1>

          <p style={{ fontSize: 14, lineHeight: 1.6, color: '#4b5563', margin: '0 0 18px' }}>
            Isso pode acontecer por sessão antiga, cache do navegador, extensão interferindo ou instabilidade momentânea.
          </p>

          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={this.limparERecarregar}
              style={{
                border: 0,
                borderRadius: 10,
                padding: '11px 16px',
                background: '#1d4ed8',
                color: '#fff',
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              Limpar sessão e recarregar
            </button>
            <button
              onClick={this.recarregar}
              style={{
                border: '1px solid #d1d5db',
                borderRadius: 10,
                padding: '11px 16px',
                background: '#fff',
                color: '#111827',
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              Tentar novamente
            </button>
          </div>

          {this.state.message && (
            <details style={{ marginTop: 18, textAlign: 'left' }}>
              <summary style={{ cursor: 'pointer', color: '#6b7280', fontSize: 12 }}>
                Detalhes técnicos
              </summary>
              <pre style={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                background: '#f9fafb',
                color: '#374151',
                padding: 12,
                borderRadius: 10,
                fontSize: 12,
              }}>
                {this.state.message}
              </pre>
            </details>
          )}
        </div>
      </div>
    )
  }
}
